import { parseNumberArg, parseStringArg } from '@/utils/string'

import type { RouteRecordRaw } from 'vue-router'

export default [
  {
    path: 'role/list',
    name: 'role-list',
    meta: { title: '角色列表', componentName: 'RoleList' },
    component: () => import('@/views/pc/platform/RoleList.vue'),
    props: true
  },
  {
    path: 'role/:roleId(\\d+)',
    name: 'role-info',
    meta: { title: '角色信息', componentName: 'RoleInfo' },
    component: () => import('@/views/pc/platform/RoleInfo.vue'),
    props: (to) => ({ roleId: parseNumberArg(to.params.roleId) })
  },
  {
    path: 'role/privilege/:roleId(\\d+)',
    name: 'role-privilege',
    meta: { title: '角色权限', componentName: 'RolePrivilege' },
    component: () => import('@/views/pc/platform/RolePrivilege.vue'),
    props: (to) => ({ roleId: parseNumberArg(to.params.roleId) })
  },
  {
    path: 'config/list',
    name: 'config-list',
    meta: { title: '配置列表', componentName: 'ConfigList' },
    component: () => import('@/views/pc/platform/ConfigList.vue'),
    props: true
  },
  {
    path: 'config/:configId(\\d+)',
    name: 'config-info',
    meta: { title: '配置信息', componentName: 'ConfigInfo' },
    component: () => import('@/views/pc/platform/ConfigInfo.vue'),
    props: (to) => ({ configId: parseNumberArg(to.params.configId) })
  },
  {
    path: 'config/system',
    name: 'config-system',
    meta: { title: '系统配置', componentName: 'SystemConfig' },
    component: () => import('@/views/pc/platform/SystemConfig.vue')
  },
  {
    path: 'dict/list',
    name: 'dict-list',
    meta: { title: '字典类型列表', componentName: 'DictTypeList' },
    component: () => import('@/views/pc/platform/DictTypeList.vue'),
    props: true
  },
  {
    path: 'dict/:typeId(\\d+)',
    name: 'dict-info',
    meta: { title: '字典类型信息', componentName: 'DictTypeInfo' },
    component: () => import('@/views/pc/platform/DictTypeInfo.vue'),
    props: (to) => ({ typeId: parseNumberArg(to.params.typeId) })
  },
  {
    path: 'dict/:typeId(\\d+)/list',
    name: 'dict-data-list',
    meta: { title: '字典数据列表', componentName: 'DictDataList' },
    component: () => import('@/views/pc/platform/DictDataList.vue'),
    props: (to) => ({ typeId: parseNumberArg(to.params.typeId) })
  },
  {
    path: 'dict/:typeId(\\d+)/:dataId(\\d+)',
    name: 'dict-data-info',
    meta: { title: '字典数据信息', componentName: 'DictDataInfo' },
    component: () => import('@/views/pc/platform/DictDataInfo.vue'),
    props: (to) => ({
      typeId: parseNumberArg(to.params.typeId),
      dataId: parseNumberArg(to.params.dataId)
    })
  },
  {
    path: 'job/list',
    name: 'job-list',
    meta: { title: '任务列表', componentName: 'JobList' },
    component: () => import('@/views/pc/platform/JobList.vue'),
    props: true
  },
  {
    path: 'job/new',
    name: 'new-job-info',
    meta: { title: '新建任务', componentName: 'JobInfo' },
    component: () => import('@/views/mb/platform/JobInfo.vue'),
    props: () => ({ jobGroup: '', jobName: '' })
  },
  {
    path: 'job/:jobGroup/:jobName',
    name: 'job-info',
    meta: { title: '任务信息', componentName: 'JobInfo' },
    component: () => import('@/views/pc/platform/JobInfo.vue'),
    props: (to) => ({ jobGroup: parseStringArg(to.params.jobGroup), jobName: parseStringArg(to.params.jobName) })
  },
  {
    path: 'job/:jobGroup/:jobName/triggers',
    name: 'trigger-list',
    meta: { title: '策略列表', componentName: 'TriggerList' },
    component: () => import('@/views/pc/platform/TriggerList.vue'),
    props: (to) => ({ jobGroup: parseStringArg(to.params.jobGroup), jobName: parseStringArg(to.params.jobName) })
  },
  {
    path: 'job/:jobGroup/:jobName/:triggerGroup/:triggerName',
    name: 'trigger-info',
    meta: { title: '策略信息', componentName: 'TriggerInfo' },
    component: () => import('@/views/pc/platform/TriggerInfo.vue'),
    props: (to) => ({
      jobGroup: parseStringArg(to.params.jobGroup),
      jobName: parseStringArg(to.params.jobName),
      triggerGroup: parseStringArg(to.params.triggerGroup),
      triggerName: parseStringArg(to.params.triggerName)
    })
  },
  {
    path: 'job/:jobGroup/:jobName/new',
    name: 'new-trigger-info',
    meta: { title: '新建策略', componentName: 'TriggerInfo' },
    component: () => import('@/views/pc/platform/TriggerInfo.vue'),
    props: (to) => ({
      jobGroup: parseStringArg(to.params.jobGroup),
      jobName: parseStringArg(to.params.jobName),
      triggerGroup: '',
      triggerName: ''
    })
  },
  {
    path: 'category/list',
    name: 'category-list',
    meta: { title: '类目列表', componentName: 'CategoryList' },
    component: () => import('@/views/pc/platform/CategoryList.vue'),
    props: true
  },
  {
    path: 'category/:parentId(\\d+)/list',
    name: 'category-children',
    meta: { title: '子类目列表', componentName: 'CategoryList' },
    component: () => import('@/views/pc/platform/CategoryList.vue'),
    props: (to) => ({ parentId: parseNumberArg(to.params.parentId) })
  },
  {
    path: 'category/:categoryId(\\d+)',
    name: 'category-info',
    meta: { title: '类目信息', componentName: 'CategoryInfo' },
    component: () => import('@/views/pc/platform/CategoryInfo.vue'),
    props: (to) => ({ categoryId: parseNumberArg(to.params.categoryId), parentId: parseNumberArg(to.query.parentId) })
  },
  {
    path: 'privilege/:parentId(\\d+)/list',
    name: 'privilege-list',
    meta: { title: '权限列表', componentName: 'PrivilegeList' },
    component: () => import('@/views/pc/platform/PrivilegeList.vue'),
    props: (to) => ({ parentId: parseNumberArg(to.params.parentId) })
  },
  {
    path: 'privilege/:privilegeId(\\d+)',
    name: 'privilege-info',
    meta: { title: '权限信息', componentName: 'PrivilegeInfo' },
    component: () => import('@/views/pc/platform/PrivilegeInfo.vue'),
    props: (to) => ({ privilegeId: parseNumberArg(to.params.privilegeId) })
  },
  {
    path: 'tag/list/:tagType',
    name: 'tag-list',
    meta: { title: '标签列表', componentName: 'TagList' },
    component: () => import('@/views/pc/platform/TagList.vue'),
    props: (to) => ({ tagType: parseStringArg(to.params.tagType, 'upper') })
  },
  {
    path: 'tag/:tagType/:tagId(\\d+)',
    name: 'tag-info',
    meta: { title: '标签信息', componentName: 'TagInfo' },
    component: () => import('@/views/pc/platform/TagInfo.vue'),
    props: (to) => ({ tagId: parseNumberArg(to.params.tagId), tagType: parseStringArg(to.params.tagType, 'upper') })
  },
  {
    path: 'message/list',
    name: 'message-list',
    meta: { title: '消息列表', componentName: 'NotifyMessageList' },
    component: () => import('@/views/pc/platform/NotifyMessageList.vue'),
    props: true
  },
  {
    path: 'message/:messageId(\\d+)',
    name: 'message-info',
    meta: { title: '消息信息', componentName: 'NotifyMessageInfo' },
    component: () => import('@/views/pc/platform/NotifyMessageInfo.vue'),
    props: (to) => ({ messageId: Number(to.params.messageId) })
  }
] as RouteRecordRaw[]
